/*
 * Ryan O'Dowd
 * 2024-05-24
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({colors, fonts}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
    },
    tabLabel: {
      color: colors.primaryExtraLight,
      fontFamily: fonts.secondaryBold,
      fontSize: 16,
      marginVertical: 12,
      marginHorizontal: 16,
    },
    selectedTabLabel: {
      color: colors.accent,
    },
    tab: {
      borderWidth: 2,
      borderRadius: 12,
    },
    selectedTab: {
      borderColor: colors.primary,
    },
  };
};

export default getStyles;
